module.exports = __webpack_public_path__ + "acd459f05ec8d49636c3da8dbd538822.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WW-NAM.svg
// module id = tQcU
// module chunks = 0